<div class="modal-container confirmation-personalinfo-modal-container">
  <div class="modal-content" [ngClass]="activeLanguage$ | async">
    <div class="modal-header d-flex align-items-center">
      <h4 class="modal-title">{{ 'personalInfo.confirmationModalTitle' | cxTranslate }}</h4>
      <button class="btn btn-link p-0 my-auto border-0 ml-auto close" aria-label="Close" (click)="closeModal()">
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <p class="question-text">{{ 'personalInfo.confirmationQuestion' | cxTranslate }}</p>
      <p class="body-text">{{ 'personalInfo.confirmationModalBody' | cxTranslate }}</p>
    </div>
    <div class="modal-footer justify-content-sm-between justify-content-md-end">
      <button type="button" class="btn secondary-btn" (click)="closeModal()">
        {{ 'common.cancel' | cxTranslate }}
      </button>
      <button type="button" class="btn primary-btn" (click)="confirmPersonalInfo()" [ngClass]="activeLanguage$ | async">
        {{ 'personalInfo.requestButton' | cxTranslate }}
      </button>
    </div>
  </div>
</div>
